export default __webpack_public_path__ + "static/media/trybudtender-screen.ae84ec67.png";